import { apiBuilder, prefixApi } from "@zodios/core";
import { z } from "zod";

const orgPropertyUpdateSchema = z.object({
  org_ids: z.array(z.number()),
  updates: z.array(
    z.object({
      field: z.literal("tags").or(z.literal("visibility")),
      action: z.union([z.literal("set"), z.literal("remove"), z.literal("add")]),
      value: z
        .string()
        .array()
        .or(z.object({ visibility: z.string(), marketplace: z.string() })),
    }),
  ),
});

export type OrgPropertyUpdateSchema = z.infer<typeof orgPropertyUpdateSchema>;

export const orgBulkActionApiDefinitions = prefixApi(
  "/api",
  apiBuilder({
    alias: "bulkUpdateOrgProperties",
    method: "post",
    path: "/bulk_update_orgs/",
    parameters: [
      {
        name: "body",
        type: "Body",
        schema: orgPropertyUpdateSchema,
      },
    ],
    status: 204,
    response: z.unknown(),
  }).build(),
);
